import { render, staticRenderFns } from "./ProgramProductCustomization.vue?vue&type=template&id=3f454f9e&scoped=true&"
import script from "./ProgramProductCustomization.vue?vue&type=script&lang=js&"
export * from "./ProgramProductCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ProgramProductCustomization.vue?vue&type=style&index=0&id=3f454f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f454f9e",
  null
  
)

export default component.exports